import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import tableLiveAppsNewComposeExperienceUrls from './tableLiveAppsNewComposeExperienceUrls';

export default {
  title: 'Media Urls',
  attributeName: 'composeExperience',
  refreshUpdate: true,
  fields: [
    {
      attributeName: 'composeExperiencesUrls',
      type: FormInputTypes.TABLE,
      label: '',
      helpText: '',
      configFile: tableLiveAppsNewComposeExperienceUrls,
    },
  ],
};
